export default __webpack_public_path__ + "static/media/blur-leaf-3.a05a4724.png";